module.exports = __webpack_public_path__ + "img/1557614101923962881.c15aa6ad.png";